import React, { useState } from 'react';
import './VisualSelector.css';

/**
 * A modern selection component that replaces checkboxes with interactive tags/cards.
 * Supports search and category grouping.
 */
const VisualSelector = ({
    items = [],
    selectedIds = [],
    onToggle,
    title,
    subtitle,
    placeholder = "Search...",
    categoryKey = null
}) => {
    const [search, setSearch] = useState('');

    const filteredItems = items.filter(item => {
        const label = item.slug || item.name || '';
        return label.toLowerCase().includes(search.toLowerCase());
    });

    const groupedItems = categoryKey
        ? Object.entries(filteredItems.reduce((acc, item) => {
            const cat = item[categoryKey] || 'Others';
            if (!acc[cat]) acc[cat] = [];
            acc[cat].push(item);
            return acc;
        }, {}))
        : [['All', filteredItems]];

    return (
        <div className="visual-selector">
            <div className="selector-header">
                <div className="title-group">
                    {title && <h4>{title}</h4>}
                    {subtitle && <p className="selector-subtitle">{subtitle}</p>}
                </div>
                <div className="search-box">
                    <input
                        type="text"
                        placeholder={placeholder}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <div className="selector-content">
                {groupedItems.map(([category, catItems]) => (
                    <div key={category} className="selector-group">
                        <div className="group-title">{category.toUpperCase()}</div>
                        <div className="items-grid">
                            {catItems.map(item => {
                                const isSelected = selectedIds.includes(item.id);
                                return (
                                    <div
                                        key={item.id}
                                        className={`selectable-item ${isSelected ? 'selected' : ''}`}
                                        onClick={() => onToggle(item.id)}
                                        title={item.description || ''}
                                    >
                                        <div className="item-label">{item.slug || item.name}</div>
                                        {isSelected && <div className="selected-indicator">✓</div>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
                {filteredItems.length === 0 && (
                    <div className="no-results">No matches found</div>
                )}
            </div>
        </div>
    );
};

export default VisualSelector;
